import React from 'react'
import './techstack.css'
import img from '../../assets/Images/Img5.png'
const TechStack = () => {
  return (
    <div className='techStackSection row overflow'>
      <div className="techStackSectionRight col-lg-6 col-md-12 rightleftSide" data-aos="fade-left">
        <div className="techStackSection_image image">
          <img src={img} alt="" />
        </div>
      </div>
      <div className="techStackSectionLeft col-lg-6 col-md-12">
        <h3 className="techStack_title">TECH STACK:</h3>
        <div className="tech_section1" data-aos="fade-up">
          <p>Languages:</p>
          <div className="tech_section2">
            <img src="https://img.shields.io/badge/HTML5-E34F26?logo=html5&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/CSS3-1572B6?logo=css3&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/JavaScript-323330?logo=javascript&logoColor=F7DF1E" alt="" />
            <img src="https://img.shields.io/badge/TypeScript-007ACC?logo=typescript&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/C-00599C?logo=c&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/C%2B%2B-00599C?logo=c%2B%2B&logoColor=white" alt="" />
          </div>
        </div>
        <div className="tech_section1" data-aos="fade-up">
          <p>JS Framework/Library:</p>
          <div className="tech_section2">
            <img src="https://img.shields.io/badge/React.Js-20232A?logo=react&logoColor=61DAFB" alt="" />
            <img src="https://img.shields.io/badge/Next.Js-000000?logo=nextdotjs&logoColor=white" alt="" />
          </div>
        </div>
        <div className="tech_section1" data-aos="fade-up">
          <p>CSS Framework/Library/Pre-processors:</p>
          <div className="tech_section2">
            <img src="https://img.shields.io/badge/Bootstrap-563D7C?logo=bootstrap&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/MUI-007FFF?logo=mui&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/Tailwind_CSS-38B2AC?logo=tailwind-css&logoColor=white" alt="" />
          </div>
        </div>
        <div className="tech_section1" data-aos="fade-up">
          <p>Database:</p>
          <div className="tech_section2">
            <img src="https://img.shields.io/badge/MongoDB-4EA94B?logo=mongodb&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/MySQL-005C84?logo=mysql&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/Firebase-ffca28?logo=firebase&logoColor=black" alt="" />
            
          </div>
        </div>
        <div className="tech_section1" data-aos="fade-up">
          <p>Backend:</p>
          <div className="tech_section2">
            <img src="https://img.shields.io/badge/Node.Js-339933?logo=nodedotjs&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/Express.Js-000000?logo=express&logoColor=white" alt="" />
          </div>
        </div>
        <div className="tech_section1" data-aos="fade-up">
          <p>Tools:</p>
          <div className="tech_section2">
            <img src="https://img.shields.io/badge/GitHub-100000?logo=github&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/GIT-E44C30?logo=git&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/VS Code-0078d7.svg?logo=visual-studio-code&logoColor=white" alt="" />
            <img src="https://img.shields.io/badge/Figma-%23F24E1E.svg?logo=figma&logoColor=white" alt="" />
          </div>
        </div>
      </div>

    </div>
  )
}

export default TechStack
